import { View, Text, Image } from "@react-pdf/renderer";
import styles from "./styles";

export default function FooterCard() {
    return (
        <View style={styles.noteBox}>
            <View style={styles.noteRow}>
                <Image src="/images/icons/heart.png" style={styles.icon} />
                <Text style={styles.noteText}>از خرید شما سپاسگزاریم</Text>
            </View>
            <Text style={styles.noteText}>cafedaru.shop</Text>
        </View>
    );
}
